import React from 'react';
import { motion } from 'framer-motion';

const LEFT_IMAGE = '/flyer-phone-discover.png';
const RIGHT_IMAGE = '/flyer-phone-plans.png';

const floatAnimation = (offset) => ({
  y: [0, offset, 0],
  transition: {
    duration: 6,
    repeat: Infinity,
    ease: 'easeInOut',
  },
});

const PhoneFrame = ({ image, alt, className, style, delay, testId, floatOffset = -4, objectPosition = 'center top' }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 1, delay, ease: [0.25, 0.1, 0.25, 1] }}
    className={`absolute ${className}`}
    style={style}
    data-testid={testId}
  >
    <motion.div
      animate={floatAnimation(floatOffset)}
      whileHover={{ scale: 1.03 }}
      transition={{ scale: { duration: 0.3, ease: 'easeOut' } }}
    >
    <div
      className="relative w-[220px] sm:w-[240px] lg:w-[260px] rounded-[36px] border-[5px] border-zinc-700/80 bg-black overflow-hidden"
      style={{
        boxShadow: '0 25px 60px rgba(0, 0, 0, 0.5), 0 0 60px rgba(255, 79, 0, 0.06)',
      }}
    >
      {/* Notch */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[90px] h-[20px] bg-black rounded-b-2xl z-20" />
      {/* Screen */}
      <div className="relative aspect-[9/19.5] w-full overflow-hidden rounded-[31px]">
        <img
          src={image}
          alt={alt}
          className="w-full h-full object-cover"
          style={{
            objectPosition,
            filter: 'brightness(1.2) contrast(1.08) saturate(1.1)',
          }}
          data-testid={`${testId}-image`}
        />
      </div>
    </div>
    </motion.div>
  </motion.div>
);

const PhoneMockup = () => {
  return (
    <div
      className="relative w-[320px] sm:w-[380px] lg:w-[420px] h-[480px] sm:h-[520px] lg:h-[560px]"
      data-testid="phone-mockup"
    >
      {/* Back phone — left screenshot */}
      <PhoneFrame
        image={LEFT_IMAGE}
        alt="Prevy app - captura izquierda"
        className="top-4 sm:top-2 left-0"
        style={{ transform: 'rotate(-6deg)' }}
        delay={0.5}
        testId="phone-left"
        floatOffset={-4}
        objectPosition="center 42%"
      />

      {/* Front phone — right screenshot */}
      <PhoneFrame
        image={RIGHT_IMAGE}
        alt="Prevy app - captura derecha"
        className="top-8 sm:top-6 right-0 z-10"
        style={{ transform: 'rotate(5deg)' }}
        delay={0.8}
        testId="phone-right"
        floatOffset={-3}
        objectPosition="center 32%"
      />

      {/* Glow beneath phones */}
      <div
        className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-[280px] h-[50px] rounded-full"
        style={{
          background: 'radial-gradient(ellipse, rgba(255, 79, 0, 0.1) 0%, transparent 70%)',
          filter: 'blur(20px)',
        }}
      />
    </div>
  );
};

export default PhoneMockup;
